import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraFormField, SpecraInput, SpecraSelect, SpecraTextarea } from '@mono/ui-components';
export function TextField({ label, value, onChange, testId, multiline = false, error, required, hint }) {
    const Control = multiline ? SpecraTextarea : SpecraInput;
    return /*#__PURE__*/ _jsx(SpecraFormField, {
        label: label,
        error: error || undefined,
        required: required,
        hint: hint,
        children: /*#__PURE__*/ _jsx(Control, {
            "data-testid": testId,
            value: value,
            onChange: (e)=>onChange(e.target.value)
        })
    });
}
export function Choice({ label, value, options, onChange, testId, required }) {
    return /*#__PURE__*/ _jsx(SpecraFormField, {
        label: label,
        required: required,
        children: /*#__PURE__*/ _jsx(SpecraSelect, {
            className: "w-full rounded-md border bg-background p-2",
            "data-testid": testId,
            value: value,
            onChange: (e)=>onChange(e.target.value),
            children: options.map((o)=>/*#__PURE__*/ _jsx("option", {
                    value: o.value,
                    disabled: o.disabled,
                    children: o.label
                }, o.value))
        })
    });
}
export function Facts({ title, children }) {
    return /*#__PURE__*/ _jsxs("section", {
        className: "space-y-2 rounded-md border p-3",
        children: [
            /*#__PURE__*/ _jsx("h3", {
                className: "font-semibold",
                children: title
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "whitespace-pre-wrap text-sm",
                children: children
            })
        ]
    });
}
export const lines = (value)=>value.split('\n').filter((v)=>v.trim());
export const options = (values)=>values.map((value)=>({
            value,
            label: value.replace(/_/g, ' ')
        }));
